import { createSlice } from '@reduxjs/toolkit';

const noticeSlice = createSlice({
  name: 'notices',
  initialState: { notices: [], loaded: false },
  reducers: {
    setNotices: (state, action) => { state.notices = action.payload; state.loaded = true; },
  },
});

export const { setNotices } = noticeSlice.actions;
export default noticeSlice;
